import { render } from "./FruitCard.vue?vue&type=template&id=da30b586"
import script from "./FruitCard.vue?vue&type=script&lang=js"
export * from "./FruitCard.vue?vue&type=script&lang=js"
script.render = render

export default script